import { Link, useLocation } from 'react-router-dom';
import { Button } from '../../components/ui/Button';
import { AlertTriangleIcon } from '../../components/ui/Icons';
import { loginState } from '../../utils/authRedirect';
import { OUTLINE_LINK_BUTTON_CLASS } from './styles';

export function SessionExpiredNotice({ onContinueAsGuest }: { onContinueAsGuest: () => void }) {
  const location = useLocation();

  return (
    <div role="alert" className="rounded-2xl border border-warning/60 bg-warning/15 p-4 sm:p-5 mb-4 sm:mb-6">
      <div className="flex items-start gap-3">
        <AlertTriangleIcon className="w-6 h-6 shrink-0 mt-0.5 text-text-dark" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-text-dark">Sua sessão expirou e o pedido não foi enviado</p>
          <p className="text-sm text-text-medium mt-0.5">
            Suas escolhas de pagamento e observações foram mantidas. Entre novamente ou continue como visitante preenchendo seus dados.
          </p>
          <div className="mt-4 flex flex-col sm:flex-row gap-2">
            <Link
              to="/login"
              state={loginState(location)}
              className={`${OUTLINE_LINK_BUTTON_CLASS} !text-base !py-2 w-full sm:w-auto`}
            >
              Entrar novamente
            </Link>
            <Button variant="ghost" onClick={onContinueAsGuest} className="w-full sm:w-auto min-h-[44px]">
              Continuar como visitante
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
